// Admin user configuration
// Hardcoded admin user IDs and emails

export const ADMIN_USER_IDS = [
  '0cf23ffa-6fdd-47f6-a8b0-121bb65b6e0b', // michaelsoluwakayode@gmail.com
  'a9db92bc-adbe-42f4-9d28-570a255f3003', // oyinloluwa18@gmail.com
];

export const ADMIN_EMAILS = [
  'michaelsoluwakayode@gmail.com',
  'oyinloluwa18@gmail.com',
];

export function isAdminUser(userId: string): boolean {
  return ADMIN_USER_IDS.includes(userId);
}

export function isAdminEmail(email: string): boolean {
  return ADMIN_EMAILS.includes(email.toLowerCase());
}

export function hasAdminAccess(userId?: string, email?: string): boolean {
  return Boolean((userId && isAdminUser(userId)) || (email && isAdminEmail(email)));
}

export async function checkAdminAccess(userId: string, email?: string): Promise<boolean> {
  // Check by user ID first
  if (isAdminUser(userId)) {
    return true;
  }
  
  // Check by email as fallback
  if (email && isAdminEmail(email)) {
    return true;
  }
  
  return false;
}
